import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const logos = [{
  name: "Aura Logistics",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_acme_corp.png"
}, {
  name: "Vector Dynamics",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_quantum_systems.png"
}, {
  name: "Pillar Group",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_echo_valley.png"
}, {
  name: "Lumina Systems",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_nebula_tech.png"
}, {
  name: "Apex Solutions",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_global_solutions.png"
}, {
  name: "Zenith Corp",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_apex_innovations.png"
}, {
  name: "Core Industries",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/logo_horizon_group.png"
}];
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function TestimonialsClientLogos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21757" id="trusted-by-brands" ref={ref} className={`py-24 bg-muted transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-sans font-bold tracking-tight mb-4 text-foreground">
            Why Work With Us
          </h2>
          <ul className="text-secondary max-w-2xl mx-auto text-lg font-sans space-y-2 list-none">
            <li>10+ years manufacturing experience</li>
            <li>Direct factory (no middleman)</li>
            <li>Stable quality control</li>
          </ul>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-24">
          <img src="https://watches-wholesaler.com/wp-content/uploads/2026/05/9ab06045-44ed-481d-a812-678257c96394.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/testimonial1.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/testimonial1.png-wvc-sizes" alt="Customer testimonial screenshot 1" className="w-full max-w-sm rounded-lg shadow-md object-cover" loading="lazy" />
          <img src="https://watches-wholesaler.com/wp-content/uploads/2026/05/94a24d62-7b1f-4dee-b509-0ac29eea61fa.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/testimonial2.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/testimonial2.png-wvc-sizes" alt="Customer testimonial screenshot 2" className="w-full max-w-sm rounded-lg shadow-md object-cover" loading="lazy" />
          <img src="https://watches-wholesaler.com/wp-content/uploads/2026/05/c9057833-46a2-4c2c-b78e-a209adce5599.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/testimonial3.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/testimonial3.png-wvc-sizes" alt="Customer testimonial screenshot 3" className="w-full max-w-sm rounded-lg shadow-md object-cover" loading="lazy" />
        </div>

        
      </div>
    </section>;
}